export const th = {
  appName: "Verena LiveTask",
  loginTitle: "เข้าสู่ระบบ",
  loginHint: "กรอกบัญชีผู้ใช้เพื่อจัดการ Verena LiveTask",
  email: "อีเมล",
  password: "รหัสผ่าน",
  signIn: "เข้าสู่ระบบ",
  signOut: "ออกจากระบบ",
  idleWarning: "ไม่มีการใช้งาน — ระบบจะออกจากบัญชีใน 1 นาที",
  idleLiveWarning: "ไม่มีการใช้งาน — ระบบจะออกจากบัญชีใน 1 นาที โดยไลฟ์จะยังคงทำงานอยู่",
  autoLoggedOut: "ระบบออกจากบัญชีอัตโนมัติเนื่องจากไม่มีการใช้งาน",
  sessionExpired: "Session หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง",
  continueWorking: "ใช้งานต่อ",
  endDraftRestored: "กู้คืนข้อมูลจบไลฟ์ที่ยังไม่ได้ส่งจากเครื่องนี้แล้ว กรุณาตรวจสอบก่อนบันทึก",
  discardEndDraft: "ลบร่างที่บันทึกไว้",
  endDraftHint: "ร่างนี้เก็บอยู่ในเครื่องนี้สูงสุด 7 วัน กรุณาอย่าล้างข้อมูลเบราว์เซอร์ระหว่างที่ยังต้องใช้",
  startDraftRestored: "กู้คืนข้อมูลเริ่มไลฟ์ที่ยังไม่ได้ส่งจากเครื่องนี้แล้ว กรุณาตรวจสอบก่อนกด START",
  discardStartDraft: "ลบร่างที่บันทึกไว้",
  startDraftHint: "ร่างนี้รวมรูปที่เลือกไว้ และเก็บอยู่ในเครื่องนี้สูงสุด 7 วัน",
  users: "จัดการผู้ใช้",
  platforms: "แพลตฟอร์ม",
  products: "รายการสินค้า",
  settings: "ตั้งค่าระบบ",
  audit: "บันทึกการใช้งาน",
  loading: "กำลังโหลด…",
  save: "บันทึก",
  cancel: "ยกเลิก",
  delete: "ลบ",
  edit: "แก้ไข",
  editUser: "แก้ไขผู้ใช้",
  editPlatform: "แก้ไขแพลตฟอร์ม",
  add: "เพิ่ม",
  name: "ชื่อ",
  role: "บทบาท",
  status: "สถานะ",
  active: "ใช้งาน",
  inactive: "ปิดใช้งาน",
  employment: "ประเภทการจ้าง",
  fullTime: "พนักงานประจำ",
  partTime: "พาร์ตไทม์",
  admin: "ผู้ดูแลระบบ",
  streamer: "สตรีมเมอร์",
  addUser: "เพิ่มผู้ใช้",
  profileImage: "รูปโปรไฟล์",
  changeProfileImage: "เปลี่ยนรูปโปรไฟล์",
  profileImageHint: "JPG, PNG, WebP หรือ HEIC ขนาดไม่เกิน 20 MB · ระบบย่อรูปให้อัตโนมัติ",
  invalidProfileImage: "ไม่สามารถประมวลผลรูปนี้ได้ กรุณาเลือกรูป JPG, PNG, WebP หรือ HEIC ขนาดไม่เกิน 20 MB",
  profileImageSaved: "บันทึกรูปโปรไฟล์แล้ว",
  uploadingFile: "กำลังอัปโหลดไฟล์…",
  uploadFailed: "อัปโหลดไม่สำเร็จ กรุณาตรวจการเชื่อมต่อแล้วลองอีกครั้ง",
  myAccount: "บัญชีของฉัน",
  saveProfileImage: "บันทึกรูปโปรไฟล์",
  changePassword: "เปลี่ยนรหัสผ่าน",
  currentPassword: "รหัสผ่านปัจจุบัน",
  confirmNewPassword: "ยืนยันรหัสผ่านใหม่",
  changePasswordHint: "เมื่อเปลี่ยนสำเร็จ อุปกรณ์อื่นที่เข้าสู่ระบบอยู่จะถูกออกจากระบบ",
  passwordChanged: "เปลี่ยนรหัสผ่านสำเร็จ",
  passwordConfirmationMismatch: "รหัสผ่านใหม่และการยืนยันไม่ตรงกัน",
  currentPasswordIncorrect: "รหัสผ่านปัจจุบันไม่ถูกต้อง",
  newPasswordMustDiffer: "รหัสผ่านใหม่ต้องไม่เหมือนรหัสผ่านปัจจุบัน",
  statusSaveFailed: "ระบบยังไม่ได้บันทึกสถานะ กรุณาลองอีกครั้ง",
  pendingActivation: "บัญชีใหม่จะเปิดใช้งานผ่านอีเมลในระยะถัดไป",
  addPlatform: "เพิ่มแพลตฟอร์ม",
  url: "URL",
  color: "สี",
  icon: "ไอคอน",
  addProduct: "เพิ่มสินค้า",
  category: "หมวดหมู่",
  productName: "ชื่อสินค้า",
  productLimit: "สูงสุด 50 รายการที่ใช้งานต่อหมวด",
  rates: "อัตราและเป้าหมาย",
  partTimeRate: "อัตราค่าแรงพาร์ตไทม์ต่อชั่วโมง (บาท)",
  fullTimeRate: "อัตราค่าแรงพนักงานประจำต่อชั่วโมง (บาท)",
  commissionRate: "คอมมิชชั่น Affiliate (%)",
  roiGood: "ROI ดี (ตั้งแต่)",
  roiOk: "ROI พอใช้ (ตั้งแต่)",
  autoCloseHours: "ปิดไลฟ์อัตโนมัติหลัง (ชั่วโมง)",
  telegramChatIds: "Telegram Chat IDs",
  settingsRatesTitle: "ต้นทุนและอัตรา",
  settingsRoiTitle: "เกณฑ์การประเมิน ROI",
  settingsPreviewTitle: "ตัวอย่างการคำนวณ",
  settingsTelegramTitle: "การแจ้งเตือน Telegram",
  partTimeRateHint: "ใช้กับ session ของพนักงานพาร์ตไทม์ โดยไม่ขึ้นกับเวลาไลฟ์",
  fullTimeRateHint: "ใช้กับ session ของพนักงานประจำ โดยไม่ขึ้นกับเวลาไลฟ์",
  commissionRateHint: "เปอร์เซ็นต์จากยอดขาย Affiliate (0–100%)",
  autoCloseHoursHint: "กำหนดได้ 1–12 ชั่วโมง ระบบเตือนก่อนปิด 30 นาที",
  roiGoodHint: "ต้องมากกว่าเกณฑ์ ROI พอใช้",
  roiOkHint: "ต่ำกว่าค่านี้จะแสดงว่าต่ำกว่าเป้า",
  settingsPreviewScenario: "ตัวอย่าง: ไลฟ์ 2 ชั่วโมง · ยอด Verena 10,000 บาท · Affiliate 4,000 บาท",
  settingsPreviewPartTime: "ค่าแรงพาร์ตไทม์ (2 ชั่วโมง)",
  settingsPreviewFullTime: "ค่าแรงพนักงานประจำ (2 ชั่วโมง)",
  settingsPreviewCommission: "คอมมิชชั่น",
  settingsPreviewRevenue: "รายได้สุทธิ",
  roiExcellent: "ดี",
  roiAcceptable: "พอใช้",
  roiBelowTarget: "ต่ำกว่าเป้า",
  telegramChatIdsHint: "กรอก Chat ID หนึ่งรายการต่อบรรทัด รองรับทั้งกลุ่มและผู้ใช้ หากเว้นว่างจะใช้ค่าเริ่มต้นของระบบ",
  testTelegram: "ทดสอบส่ง Telegram",
  telegramTestSuccess: "ส่งข้อความทดสอบสำเร็จ {count} ปลายทาง",
  telegramTestFailed: "ส่งข้อความทดสอบ Telegram ไม่สำเร็จ กรุณาตรวจ Chat ID และสิทธิ์ของบอต",
  telegramTestBotTokenMissing: "V3 Worker ยังไม่พบ TELEGRAM_BOT_TOKEN กรุณาตรวจว่า Secret ถูกบันทึกและ deploy แล้ว",
  telegramTestBotTokenInvalid: "Telegram Bot Token ไม่ถูกต้อง กรุณาคัดลอก Token จาก BotFather ใหม่โดยไม่ใส่คำว่า bot นำหน้า",
  telegramTestChatNotFound: "Telegram ไม่พบ Chat ID นี้ กรุณาตรวจเลข Chat ID และตรวจว่าบอตอยู่ในแชตหรือช่องแล้ว",
  telegramTestBotForbidden: "บอตไม่มีสิทธิ์ส่งข้อความ กรุณาเพิ่มบอตเข้าช่องและอนุญาตให้โพสต์ข้อความ",
  telegramTestRateLimited: "Telegram จำกัดการส่งชั่วคราว กรุณารอสักครู่แล้วลองใหม่",
  telegramTestUnavailable: "ไม่สามารถเชื่อมต่อ Telegram ได้ชั่วคราว กรุณาลองใหม่",
  reset: "คืนค่าเดิม",
  invalidRoiThresholds: "เกณฑ์ ROI ดีต้องมากกว่าเกณฑ์ ROI พอใช้",
  invalidSettings: "กรุณาตรวจค่าการตั้งค่า: อัตราค่าแรงต้องมากกว่า 0, คอมมิชชั่น 0–100% และเวลาปิดอัตโนมัติ 1–12 ชั่วโมง",
  invalidTelegramChatIds: "Telegram Chat ID ต้องเป็นตัวเลข โดยกรอกหนึ่งรายการต่อบรรทัดหรือคั่นด้วยจุลภาค",
  confirmRecalculateCurrentMonth: "อัตราคอมมิชชั่นเปลี่ยนแล้ว ต้องการคำนวณ session ที่จบแล้วในเดือนปัจจุบันใหม่หรือไม่?\n\nระบบจะไม่แก้เดือนก่อนหน้าและจะไม่นับ session ที่ปิดอัตโนมัติ",
  recalculatedSessions: "บันทึกการตั้งค่าและคำนวณใหม่แล้ว {count} session",
  savedWithoutRecalculation: "บันทึกการตั้งค่าแล้ว โดยไม่ได้คำนวณ session เดิมใหม่",
  reminders: "รายการเตือนก่อนเริ่มไลฟ์",
  addReminderCategory: "เพิ่มหมวด",
  addReminderItem: "เพิ่มรายการ",
  reminderTitle: "ชื่อหมวด",
  reminderItem: "รายการเตือน",
  reminderEditorHint: "แก้ไขหมวดและรายการได้โดยตรง แล้วกดบันทึกรายการเตือน",
  saveReminders: "บันทึกรายการเตือน",
  saveSuccess: "บันทึกสำเร็จ",
  requestFailed: "ไม่สามารถดำเนินการได้",
  noData: "ยังไม่มีข้อมูล",
  confirmDelete: "ยืนยันการลบรายการนี้?",
  bootstrapEyebrow: "ระยะที่ 1 · เริ่มต้นโครงการ",
  bootstrapTitle: "Verena LiveTask พร้อมสำหรับการพัฒนา",
  bootstrapBody:
    "โครงสร้างหน้าเว็บ API และฐานข้อมูลพร้อมแล้ว โดยยังแยกจากระบบ V2 โดยสิ้นเชิง",
  apiLabel: "ที่อยู่ API",
  languageButton: "English",
  dashboardTitle: "ศูนย์จัดการ V3",
  dashboardHint: "ข้อมูลนี้อยู่บนระบบ V3 ใหม่ และยังไม่กระทบระบบ V2",
  refresh: "รีเฟรช",
  create: "สร้าง",
  update: "อัปเดต",
  actions: "การจัดการ",
  enabled: "เปิดใช้งาน",
  disabled: "ปิดใช้งาน",
  createUserHint:
    "บัญชีใหม่จะได้รับอีเมลเปิดใช้งาน และยังไม่เปิดใช้จนกว่าจะตั้งรหัสผ่าน",
  pendingActivationStatus: "รอ",
  resendActivation: "ส่งคำเชิญอีกครั้ง",
  activationResent: "Brevo รับอีเมลคำเชิญแล้ว กรุณาให้ผู้รับตรวจ Inbox หรือ Spam/Junk",
  activationQueued: "ระบบรับคำขอแล้ว แต่อีเมลกำลังรอส่ง ระบบจะลองส่งใหม่อัตโนมัติ",
  lastActiveAdmin: "ระบบต้องมีผู้ดูแลที่เปิดใช้งานอย่างน้อย 1 คน",
  searchManagement: "ค้นหาชื่อหรืออีเมล",
  allStatuses: "ทุกสถานะ",
  allCategories: "ทุกหมวด",
  confirmDeactivateProduct: "ปิดใช้งานสินค้านี้? สินค้าจะหายจากฟอร์มไลฟ์ใหม่ แต่ประวัติเก่าจะไม่เปลี่ยน",
  confirmMoveProduct: "ย้ายสินค้านี้ไปหมวดอื่น?",
  productMoveBlocked: "ยังย้ายหมวดไม่ได้ เพราะมีสตรีมเมอร์กำลังไลฟ์ {count} คน: {names} กรุณารอให้จบไลฟ์ก่อน",
  platformPreview: "ตัวอย่าง",
  shopProfilePhoto: "รูปโปรไฟล์ร้าน",
  shopProfilePhotoHint: "JPEG, PNG หรือ WebP · ขนาดไม่เกิน 2.5 MB",
  productCategories: "สินค้าแยกตามหมวด",
  productStatus: "สถานะสินค้า",
  settingsHelp: "การตั้งค่าเป็นข้อมูลอ่อนไหวและเห็นได้เฉพาะผู้ดูแลระบบ",
  emptyReminders: "ยังไม่มีรายการเตือน",
  addReminder: "เพิ่มรายการเตือน",
  remove: "นำออก",
  unexpectedError: "เกิดข้อผิดพลาดที่ไม่คาดคิด",
  live: "ไลฟ์สด",
  recordLive: "บันทึกการไลฟ์",
  readyToLive: "พร้อมเริ่มไลฟ์",
  readyToLiveHint: "กดปุ่ม START เมื่อเริ่มการไลฟ์สด",
  choosePlatform: "เลือกแพลตฟอร์ม",
  liveUrlRequiredHint: "จำเป็น — วาง URL ที่ผู้ชมใช้เข้าดูไลฟ์นี้",
  issueBeforeLive: "บันทึกปัญหา / หมายเหตุ (ก่อนเริ่มไลฟ์)",
  optionalImagesHint: "รูปประกอบไม่บังคับ · สูงสุด 5 รูป",
  liveInProgress: "กำลังไลฟ์อยู่",
  platform: "แพลตฟอร์ม",
  liveUrl: "ลิงก์ไลฟ์",
  showcasePlan: "สินค้าที่วางแผนโชว์",
  actualShowcase: "สินค้าที่นำเสนอจริง",
  actualShowcaseHint: "รายการจากตอนเริ่มไลฟ์ กรุณาตรวจสอบและแก้ไขให้ตรงกับสินค้าที่นำเสนอจริงก่อนจบไลฟ์",
  checklist: "Checklist ก่อนเริ่มไลฟ์",
  scheduledNow: "ตารางไลฟ์ช่วงเวลานี้",
  scheduledNowHint: "แสดงเพื่อยืนยันเท่านั้น กรุณากรอกข้อมูลไลฟ์ด้วยตนเอง",
  noScheduledNow: "ไม่มีตารางไลฟ์ในช่วงเวลานี้",
  substituteFor: "ไลฟ์แทนสตรีมเมอร์คนอื่น",
  normalLive: "ไม่ใช่ — ไลฟ์ตามตารางของฉัน",
  faceHint: "ถ่ายรูปใบหน้าเพื่อยืนยันตัวตน · ระบบประทับวันเวลาอัตโนมัติ",
  liveElapsed: "ระยะเวลาที่ไลฟ์",
  calculationPreview: "กรอกยอดขายเพื่อดูการคำนวณ",
  startFace: "รูปใบหน้าก่อนเริ่มไลฟ์",
  endFace: "รูปใบหน้าหลังจบไลฟ์",
  optionalImages: "รูปประกอบ (ไม่บังคับ, สูงสุด 5 รูป)",
  chooseFileOrCamera: "Choose file or Open Camera",
  noFileChosen: "ยังไม่ได้เลือกไฟล์",
  startLive: "START — เริ่มไลฟ์",
  endLive: "END — จบไลฟ์",
  closeSession: "ปิด session",
  closeSessionHint: "ใช้เมื่อสตรีมเมอร์จบไลฟ์แล้วแต่ไม่สามารถปิดเองได้ ข้อมูลยอดขายจะเป็นศูนย์และจะไม่นับในรายงานจนกว่าผู้ดูแลจะตรวจสอบ",
  actualEndTime: "เวลาจบจริง",
  editSession: "แก้ไข session",
  validateLiveSession: "ตรวจสอบไลฟ์",
  validationEditHint: "ตรวจทานและแก้ไขข้อมูลด้านล่างได้ ระบบจะคำนวณระยะเวลา ค่าแรง คอมมิชชั่น และ ROI ใหม่อัตโนมัติ",
  validationSaveHint: "บันทึก: เก็บข้อมูลที่แก้ไข แต่ไม่เปลี่ยนสถานะการตรวจสอบ",
  validationConfirmHint: "ยืนยันตรวจสอบ/ตรวจสอบซ้ำ: เก็บข้อมูลพร้อมบันทึกชื่อและเวลาผู้ตรวจ",
  recalculationPreview: "ตัวอย่างการคำนวณใหม่",
  validateSession: "ยืนยันตรวจสอบ",
  revalidateSession: "ตรวจสอบซ้ำ",
  validateAndEditData: "ตรวจสอบและแก้ไข",
  validatedBy: "ตรวจสอบโดย {name} · {time}",
  verenaSales: "Verena Sales (บาท)",
  affiliateSales: "Affiliate Sales (บาท)",
  audience: "ผู้ชม",
  orderNumbers: "เลขออเดอร์",
  endNote: "หมายเหตุหลังไลฟ์",
  noActiveLive: "ยังไม่มี session ที่กำลังไลฟ์",
  liveSaved: "บันทึกไลฟ์สำเร็จ",
  liveStarted: "เริ่มไลฟ์แล้ว",
  sessionStartedAt: "เริ่มเวลา",
  dashboard: "แดชบอร์ด",
  history: "ประวัติ",
  myHistory: "ประวัติของฉัน",
  startPhotos: "รูปเริ่ม",
  endPhotos: "รูปจบ",
  photo: "รูปภาพ",
  viewDetails: "ดูรายละเอียด",
  imageUnavailable: "ไม่สามารถโหลดรูปภาพนี้ได้",
  managerReport: "รายงานผู้จัดการ",
  reportPeriod: "ช่วงรายงาน",
  generateReport: "สร้างรายงาน",
  exportReport: "ส่งออกรายงาน",
  reportOf: "รายงานของ",
  year: "ปี",
  performanceSummary: "สรุปประสิทธิภาพ",
  audiencePerHour: "ผู้ชมต่อชั่วโมง",
  totalAudience: "ผู้ชมรวม",
  total: "รวม",
  managerStartFace: "รูปเริ่ม (ใบหน้า)",
  managerEndFace: "รูปจบ (ใบหน้า)",
  managerSubstituteFor: "แทน",
  chooseReportLanguage: "เลือกภาษารายงาน",
  reportLanguageHint: "ตัวเลขและข้อมูลเหมือนกันทั้งสองภาษา",
  printOrSavePdf: "พิมพ์ / บันทึก PDF",
  backToReport: "กลับไปรายงาน",
  printHelp: "เลือก Print แล้วเลือก Save as PDF เพื่อบันทึกไฟล์",
  sortAscending: "เรียงจากน้อยไปมาก",
  sortDescending: "เรียงจากมากไปน้อย",
  resetSorting: "ยกเลิกการเรียงลำดับ",
  totalRevenue: "รายได้สุทธิ",
  totalOt: "ค่าแรงรวม",
  laborCost: "ค่าแรง",
  totalHours: "ชั่วโมงไลฟ์รวม",
  sessions: "จำนวนไลฟ์",
  revenuePerHour: "รายได้ต่อชั่วโมง",
  commission: "ค่าคอมมิชชั่น",
  actionCenter: "สรุปกิจกรรมย้อนหลัง 7 วัน",
  liveNow: "กำลังไลฟ์อยู่",
  belowTarget7d: "ROI ต่ำกว่าเป้า (7 วัน)",
  repeatedIssues7d: "ปัญหาซ้ำ (7 วัน)",
  bestPlatformWeek: "แพลตฟอร์มยอดเยี่ยมสัปดาห์นี้",
  topStreamerToday: "สตรีมเมอร์ยอดนิยมวันนี้",
  fullTimeLaborCost: "ค่าแรงพนักงานประจำ",
  partTimeLaborCost: "ค่าแรงพาร์ตไทม์",
  averageRevenue: "รายได้เฉลี่ยต่อไลฟ์",
  averageDuration: "ระยะเวลาเฉลี่ย",
  topRoiStreamer: "สตรีมเมอร์ ROI สูงสุด",
  highestRevenueHour: "รายได้/ชม. สูงสุด",
  bestPlatformRoi: "แพลตฟอร์ม ROI สูงสุด",
  streamerEfficiency: "อันดับประสิทธิภาพสตรีมเมอร์",
  platformEfficiency: "อันดับประสิทธิภาพแพลตฟอร์ม",
  dailySalesRoi: "ยอดขายและ ROI รายวัน",
  salesByStreamer: "ยอดขายแยกพนักงาน",
  roiBySlot: "ROI ตามช่วงเวลา",
  before2200: "ก่อน 22:00",
  after2200: "22:00 ขึ้นไป",
  bestLive: "ไลฟ์ที่ดีที่สุด",
  issueReports: "รายงานปัญหา",
  validation: "การตรวจสอบ",
  validated: "ตรวจสอบแล้ว",
  pendingValidation: "รอการตรวจสอบ",
  editedBy: "แก้ไขโดย {name} · {time}",
  facePhotoRequired: "กรุณาถ่ายหรือเลือกรูปใบหน้า แล้วลองอีกครั้ง",
  validationFacePhotoRequired: "ยังตรวจสอบไม่ได้: ต้องมีรูปใบหน้าเริ่มและจบไลฟ์ให้ครบ (ยกเว้นรูปจบของรายการที่ระบบปิดอัตโนมัติ)",
  autoCloseActualEndRequired: "กรุณาระบุเวลาจบจริงก่อนตรวจสอบรายการที่ระบบปิดอัตโนมัติ",
  facePhotoUploadInvalid: "ตรวจสอบไฟล์รูปใบหน้าไม่สำเร็จ กรุณาเลือกรูปและอัปโหลดใหม่",
  activeSession: "กำลังไลฟ์",
  completed: "เสร็จสิ้น",
  completedBadge: "จบแล้ว",
  date: "วันที่",
  month: "เดือน",
  applyFilters: "ใช้ตัวกรอง",
  exportPdf: "Export PDF",
  pdfLanguageTitle: "เลือกภาษาเอกสาร PDF",
  pdfLanguageHint: "เลือกภาษาที่ต้องการ ตัวเลขและข้อมูลเหมือนกันทั้งสองภาษา",
  thaiPdf: "🇹🇭 ภาษาไทย",
  englishPdf: "🇬🇧 English",
  pdfSaveHint: "หน้าต่างพิมพ์จะเปิดขึ้นเพื่อบันทึกเป็น PDF",
  pdfPopupBlocked: "ไม่สามารถเปิดหน้าต่าง Export PDF ได้ กรุณาอนุญาตป๊อปอัปแล้วลองใหม่",
  time: "เวลา",
  duration: "ระยะเวลา",
  platformPerformance: "ประสิทธิภาพตามแพลตฟอร์ม",
  streamerPerformance: "ประสิทธิภาพสตรีมเมอร์",
  issues: "ปัญหา",
  from: "จากวันที่",
  to: "ถึงวันที่",
  allStreamers: "สตรีมเมอร์ทั้งหมด",
  allPlatforms: "ทุกแพลตฟอร์ม",
  allEmployment: "ทุกประเภทการจ้าง",
  autoClosed: "ระบบปิดอัตโนมัติ",
  schedules: "ตารางไลฟ์",
  mySchedule: "ตารางของฉัน",
  addSchedule: "เพิ่มตารางไลฟ์",
  startTime: "เวลาเริ่ม",
  endTime: "เวลาจบ",
  endsNextDay: "จบวันถัดไป (+1 วัน)",
  nextDayShort: "+1 วัน",
  hour: "ชั่วโมง",
  minute: "นาที",
  confirm: "ยืนยัน",
  timePickerHint: "เลือกเวลา แล้วกด Enter หรือดับเบิลคลิกที่นาที",
  note: "หมายเหตุ",
  upcomingSchedules: "ตารางไลฟ์ที่กำลังจะมาถึง",
  noSchedules: "ยังไม่มีตารางไลฟ์",
  scheduleSubtitle: "สร้างและจัดการตารางไลฟ์ของสตรีมเมอร์",
  buildSchedule: "สร้างตาราง",
  plannedSchedules: "ตารางที่วางไว้",
  loadMonth: "โหลดเดือน",
  saveSchedule: "บันทึกตาราง",
  scheduleBuildHint: "ทุกวันเริ่มเป็นวันหยุดอัตโนมัติ · กด “เพิ่มรอบ” เพื่อเปลี่ยนเป็นวันทำงาน แล้วบันทึกตาราง",
  selectStreamerFirst: "กรุณาเลือกสตรีมเมอร์ก่อน",
  addSlot: "เพิ่มรอบ",
  dayOff: "หยุด",
  dayOffNoLive: "วันหยุด (ไม่ไลฟ์)",
  search: "ค้นหา",
  addEntry: "เพิ่มรายการ",
  editSchedule: "แก้ไขรายการไลฟ์",
  cancelSchedule: "ยกเลิกรายการ",
  pastSchedule: "ผ่านมาแล้ว",
  scheduleSaved: "บันทึกตารางเรียบร้อย",
  invalidScheduleTime: "ตรวจสอบเวลา: รอบปกติต้องจบหลังเริ่ม หรือกด +1 วันสำหรับรอบข้ามเที่ยงคืน",
  auditHelp: "ประวัติแบบอ่านอย่างเดียวของการทำงานสำคัญในระบบและการดำเนินการของผู้ดูแล",
  auditAction: "การดำเนินการ",
  auditDetail: "รายละเอียด",
  auditActor: "ผู้ดำเนินการ",
  auditAllActors: "ผู้ใช้และระบบทั้งหมด",
  auditResult: "ผลลัพธ์",
  auditSuccess: "สำเร็จ",
  auditFailure: "ไม่สำเร็จ",
  auditSecurityRejected: "ระบบความปลอดภัยปฏิเสธ",
  allActions: "ทุกการดำเนินการ",
  allResults: "ทุกผลลัพธ์",
  previousPage: "ก่อนหน้า",
  nextPage: "ถัดไป",
  historyPageSummary: "หน้า {page} จาก {pages} · ทั้งหมด {total} ไลฟ์",
  historyFilterTotals: "สรุปตามตัวกรอง",
  totalSessions: "จำนวนไลฟ์ทั้งหมด",
  rowsPerPage: "จำนวนไลฟ์ต่อหน้า",
  auditPageSummary: "หน้า {page} จาก {pages} · ทั้งหมด {total} รายการ",
  forgotPassword: "ลืมรหัสผ่าน",
  forgotPasswordHint: "กรอกอีเมลเพื่อรับลิงก์รีเซ็ตรหัสผ่าน",
  sendResetLink: "ส่งลิงก์รีเซ็ต",
  resetPassword: "ตั้งรหัสผ่านใหม่",
  newPassword: "รหัสผ่านใหม่",
  resetSent:
    "หากอีเมลนี้อยู่ในระบบ เราได้ส่งลิงก์รีเซ็ตรหัสผ่านแล้ว กรุณาตรวจสอบกล่องจดหมายและโฟลเดอร์ Spam",
  invalidEmail: "กรุณากรอกอีเมลให้ถูกต้อง",
  passwordMinLength: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร",
  backToSignIn: "กลับไปเข้าสู่ระบบ",
  showPassword: "แสดงรหัสผ่าน",
  hidePassword: "ซ่อนรหัสผ่าน",
  version: "เวอร์ชัน",
  updatedOn: "Updated on",
  bangkokTime: "Bangkok Time",
  hours: "ชั่วโมง",
  categoryFoodSupplement1: "อาหารเสริม 1",
  categoryFoodSupplement2: "อาหารเสริม 2",
  categoryCosmetic: "เครื่องสำอาง",
  categoryOtherBrand: "แบรนด์อื่น",
} as const;
